import { render, staticRenderFns } from "./RedhillCity.vue?vue&type=template&id=5d7cefe8&scoped=true&"
import script from "./RedhillCity.vue?vue&type=script&lang=js&"
export * from "./RedhillCity.vue?vue&type=script&lang=js&"
import style0 from "./RedhillCity.vue?vue&type=style&index=0&id=5d7cefe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7cefe8",
  null
  
)

export default component.exports